package com.esoris.kmpmoout.domaindata.expense

import kotlin.time.Instant

fun ExpenseDto.toExpense(): Expense {
    return Expense(
        id = id,
        userId = userId,
        amount = amount,
        category = category,
        note = note,
        createdAt = createdAt?.let { Instant.parse(it) }?.toEpochMilliseconds()
    )
}

fun Expense.toDto(): ExpenseDto {
    return ExpenseDto(
        id = id,
        userId = userId,
        amount = amount,
        category = category,
        note = note,
        createdAt = null // autogenerated
    )
}